/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Files_All_Files_In_FolderInputs */

const en_files_all_files_in_folder = /** @type {(inputs: Files_All_Files_In_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every file is already in this folder.`)
};

const es_files_all_files_in_folder = /** @type {(inputs: Files_All_Files_In_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los archivos ya están en esta carpeta.`)
};

/**
* | output |
* | --- |
* | "Every file is already in this folder." |
*
* @param {Files_All_Files_In_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_all_files_in_folder = /** @type {((inputs?: Files_All_Files_In_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_All_Files_In_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_all_files_in_folder(inputs)
	return en_files_all_files_in_folder(inputs)
});